<script setup>
import '@/assets/cloudCounter/css/style.css'
import { ref, watch, reactive } from 'vue';
import { useRouter, } from 'vue-router';
import Layout from '@/components/cloudCounter/Layout.vue'
import Process from '@/components/cloudCounter/Process.vue'
import CaseBox from '@/components/cloudCounter/CaseBox.vue'
import Loading from '@/components/Loading.vue';
import routeName from '@/router/constant.js';
import { postAgreeEndorse, postNotAgreeEndorse } from '@/apis/endorse.js';
import { getContactInfo, confirmTransaction, getResult } from '@/apis/system';

const router = useRouter();
const checkboxAgree = ref(true); //是否以電子文件寄送本次變更批註內容 checkbox
const isLoading = ref(false);
const contactInfo = reactive({
    email: '',
    mobile: ''
});
const applData = ref({
    boxList: [
        {
            title: '',
            list: []
        },
    ]
});

const insData = ref({
    boxList: [
        {
            title: '',
            list: []
        },
    ],
});

// 送出確認資料
const checkData = () => {
    // 雲端E櫃檯沒有該欄位，故固定傳'N'
    return confirmTransaction('N').then(res => res.data).catch(() => null);
};

const goNextPage = async () => {
    isLoading.value = true;
    //若有勾選批註則呼叫
    console.log("checkboxAgree:", checkboxAgree.value)
    if (checkboxAgree.value) {
        await postAgreeEndorse();
    } else {
        await postNotAgreeEndorse();
    }
    await getInfo();
    const response = await checkData();
    if (response) {
        router.push({ name: routeName.CLOUD_E_COUNTER_PHONE });
    } else {
        isLoading.value = false;
    }
};

const getResultData = () => {
    applData.value.boxList[0].list = [];
    insData.value.boxList[0].list = [];
    isLoading.value = true
    getResult().then(res => {
        applData.value.boxList[0].title = res.data.applicantInsuredNameChange.after.name;
        insData.value.boxList[0].title = res.data.applicantInsuredNameChange.after.insuredName;

        // 要保人保單列
        res.data?.applicantInsuredNameChange?.after?.policyVoList.forEach(p => {
            applData.value.boxList[0].list.push({
                key: p.fullPolicyNo,
                value: `${p.item} ${p.itemName}`,
            })
        })

        // 被保人保單列
        res.data?.applicantInsuredNameChange?.after?.insuredVoList.forEach(p => {
            insData.value.boxList[0].list.push({
                key: p.fullPolicyNo,
                value: `${p.item} ${p.itemName}`,
            })
        })
    }).finally(() => {
        isLoading.value = false
    });
}
getResultData();

const getInfo = async () => {

    isLoading.value = true;
    getContactInfo().then((res) => {
        const { email, mobile } = res.data;
        contactInfo.email = email;
        contactInfo.mobile = mobile;
    }).catch(() => {
        // 交易無法進行
        isStopChange.value = true;
    }).finally(() => {
        isLoading.value = false;
    });
};

</script>

<template>

    <Layout
        :header="{ text: '要保人或被保險人姓名變更', backBtn: { visible: true }, closeBtn: { visible: true, to: { name: routeName.CLOUD_E_COUNTER_HOME } }, }">

        <div class="pt-2 pb-6">
            <Process :steps="['選擇保單', '填寫內容', '確認資料', '視訊預約',]" :index="2"></Process>
        </div>

        <div class="pb-8 flex justify-between items-center">
            <h2 class="font-bold text-2xl">確認以下已填寫資料</h2>
            <div class=" text-[#0093C1] textsm">
                <router-link :to="router.options.history.state.back">
                    <svg class="inline-block" fill="#0093C1" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                        viewBox="0 0 24 24">
                        <title>square-edit-outline</title>
                        <path
                            d="M5,3C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V12H19V19H5V5H12V3H5M17.78,4C17.61,4 17.43,4.07 17.3,4.2L16.08,5.41L18.58,7.91L19.8,6.7C20.06,6.44 20.06,6 19.8,5.75L18.25,4.2C18.12,4.07 17.95,4 17.78,4M15.37,6.12L8,13.5V16H10.5L17.87,8.62L15.37,6.12Z" />
                    </svg>修改
                </router-link>
            </div>
        </div>

        <div class="pb-6" v-if="applData.boxList[0].title">
            <h3 class="font-bold text-xl pb-2">要保人新姓名</h3>
            <p class="pb-2" v-if="applData.boxList[0]?.list?.length > 0">將一併辦理以下保單號碼之要保人姓名變更</p>
            <CaseBox :caseBox="applData"></CaseBox>
        </div>

        <div class="pb-6" v-if="insData.boxList[0].title">
            <h3 class="font-bold text-xl pb-2">被保險人新姓名</h3>
            <p class="pb-2" v-if="insData.boxList[0]?.list?.length > 0">將一併辦理以下保單號碼之被保險人姓名變更</p>
            <CaseBox :caseBox="insData"></CaseBox>
        </div>

        <div class="pb-6">
            <h4 class="font-bold text-lg pb-3">是否以電子文件寄送本次變更批註內容</h4>
            <label class="flex">
                <div class="pt-1 pr-3">
                    <input class="w-[20px] h-[20px]" type="radio" id="checkboxAgree" :value="true"
                        v-model="checkboxAgree">
                </div>
                <p class="flex-1">
                    本次變更批註內容將以電子文件寄送至本次填寫或本人留存於貴公司之電子郵件信箱；未提供電子郵件信箱或郵件遭退回，則發送簡訊通知；若未留存行動電話或簡訊通知亦遭退回，則改以紙本寄送。若您未申請電子保單且不同意以電子文件寄送請勾選『變更批註以紙本寄送』。
                </p>
            </label>
            <label class="flex pt-1">
                <div class="pt-1 pr-3">
                    <input class="w-[20px] h-[20px]" type="radio" id="checkboxAgree" :value="false"
                        v-model="checkboxAgree">
                </div>
                <p class="flex-1">
                    變更批註以紙本寄送
                </p>
            </label>
        </div>

        <template v-slot:bottom>
            <button
                class="w-full pt-5 pb-14 text-center bg-[#0093C1] text-white disabled:bg-[#D7D8DA] disabled:text-[#86878F]"
                @click="goNextPage">下一步</button>
        </template>
        <Loading :is-loading="isLoading" />
    </Layout>

</template>

<style scoped></style>
